export default __webpack_public_path__ + "static/media/bottom.2eeb33db.svg";